module.exports = __webpack_public_path__ + "img/platinumGold.6415e65.webp";